import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { IFRInvoice, IFRProjectInvoicesResponse } from './invoice-reb.interfaces';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class InvoiceRebService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  private _API_BASE_URL: string = environment['API_URL'];

  public get(primer, quants, filters = {}, conds = {}, ordering = {}): Observable<IFRProjectInvoicesResponse[]> {
   let params = new HttpParams();
  
    Object.keys(filters)
      .filter(filter => (filters[filter] === 0 || filters[filter]))
      .forEach(filter => params = params.append(filter, filters[filter].toString().replace(/\+/g,"%2B")));

    Object.keys(conds)
      .filter(cond => (conds[cond] === 0 || conds[cond]))
      .forEach(cond => params = params.append(cond, conds[cond].toString()));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<IFRProjectInvoicesResponse[]>(this._API_BASE_URL + 'invoiceReb?primer='+primer+'&quants='+quants, this.options)
    .pipe(map(response => {
      return response || [];
    }));
  }

  constructor(private authHttp: HttpClient) { }

}
